import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../Themes/ThemeContext";
import "./Navbar.css";
import ailogodark from "../assets/ailogodark.png";
import ailogolight from "../assets/ailogolight.png";
import { IoSunny, IoMoonSharp } from "react-icons/io5";

const NavbarComponent = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isRotating, setIsRotating] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const closeMenu = () => setIsMenuOpen(false);

  const handleThemeToggle = () => {
    if (window.innerWidth <= 768) setIsMenuOpen(false);
    setIsRotating(true);
    setTimeout(() => {
      toggleTheme();
      setIsRotating(false);
    }, 500);
  };

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>
          <img src={theme === "light" ? ailogolight : ailogodark} alt="Logo" className="navbar-logo" />
        </Link>
      </div>

      <div className={`navbar-links ${isMenuOpen ? "open" : ""}`}>
        <Link to="/" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>Home</Link>
        <Link to="/about" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>About</Link>
        <Link to="/services" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>Services</Link>
        <Link to="/pricing" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>Pricing</Link>
        <Link to="/faq" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>FAQs</Link>
        <Link to="/blog" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>Blog</Link>
        <Link to="/contact" onClick={() => { closeMenu(); window.scrollTo(0, 0); }}>Contact</Link>
        <div className={`themeicon ${isRotating ? "rotate" : ""}`} onClick={handleThemeToggle}>
          {theme === "light" ? (
            <IoSunny className={`themeicon ${isRotating ? "show" : ""}`} />
          ) : (
            <IoMoonSharp className={`themeicon ${isRotating ? "show" : ""}`} />
          )}
        </div>
      </div>

      <div className="navbar-right">
        <i className="bx bx-menu" style={{ fontSize: "2.5rem", cursor: "pointer" }} onClick={toggleMenu}></i>
      </div>
    </nav>
  );
};

export default NavbarComponent;
